__turbopack_context__.v({
  "arrow": "styleDropdown-module-scss-module__P47OuW__arrow",
  "content": "styleDropdown-module-scss-module__P47OuW__content",
  "divider": "styleDropdown-module-scss-module__P47OuW__divider",
  "dropdown": "styleDropdown-module-scss-module__P47OuW__dropdown",
  "dropdownContainer": "styleDropdown-module-scss-module__P47OuW__dropdownContainer",
  "dropdownWrapper": "styleDropdown-module-scss-module__P47OuW__dropdownWrapper",
  "linkAnchor": "styleDropdown-module-scss-module__P47OuW__linkAnchor",
  "linkLabel": "styleDropdown-module-scss-module__P47OuW__linkLabel",
  "sectionTitle": "styleDropdown-module-scss-module__P47OuW__sectionTitle",
  "sectionTitleLink": "styleDropdown-module-scss-module__P47OuW__sectionTitleLink",
  "triangle": "styleDropdown-module-scss-module__P47OuW__triangle",
  "trigger": "styleDropdown-module-scss-module__P47OuW__trigger",
});
